import api from "./api";

const salaryService = {
  // ── Payroll months ─────────────────────────────────────────────────────────
  getMonths: () => api.get("/salary/months"),

  // ── Monthly payroll ────────────────────────────────────────────────────────
  getByMonth: (month, year) =>
    api.get("/salary", { params: { month, year } }),

  generate: (month, year, workingDays) =>
    api.post("/salary/generate", { month, year, workingDays }),

  finalize: (month, year) => api.put("/salary/finalize", { month, year }),

  refreshMonth: (month, year, workingDays) =>
    api.put("/salary/refresh-month", { month, year, workingDays }),

  // ── Single payslip ─────────────────────────────────────────────────────────
  getById: (id) => api.get(`/salary/${id}`),

  refreshAttendance: (id, workingDays) =>
    api.put(`/salary/${id}/refresh-attendance`, { workingDays }),

  update: (id, data) => api.put(`/salary/${id}`, data),

  remove: (id) => api.delete(`/salary/${id}`),

  // ── Employee pay history ───────────────────────────────────────────────────
  getEmployeeHistory: (employeeId) =>
    api.get(`/salary/employee/${employeeId}`),
};

export default salaryService;
